import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "highlight" })
export class HighlightPipe implements PipeTransform {
    transform(original: string, searchText, cssClass: string = "highlight"): String {
        if (typeof original !== "string" || !searchText || typeof searchText !== "string") {
            return original;
        }

        /*  Create a pattern based on the searchText
        Replace some special characters with their escape sequence
        Split the string by spaces and remove empty elements
        Finally, join remaining with '|' as separator
    */
        const pattern = searchText
            .replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&")
            .split(" ")
            .filter((t) => t.length > 0)
            .join("|");

        // Create regex using pattern for global case insensitive matches
        const regex = new RegExp(pattern, "gi");

        // If searchText exists, replace matches with span element and class, otherwise return original
        let result = searchText
            ? original.replace(regex, (match) => `<span class="${cssClass}">${match}</span>`)
            : original;

        return result;
    }
}
